angular.module(NgAppName).component('crListingTile', {
	templateUrl: 'crListingTile/crListingTile.html',
	transclude: true,
	bindings: {
		listing: '<',
		missingImage: '@',
		currentView: '@',
		activeListingMaskId: '<',
		redirectLink: '<',
		rpcSaveToProfile: '@',
		openBlimpOnClick: '<',
		open: '<',
		updateSavedApts: '@',
		useHiddenObjForImages: '<',
		goToListingPage: '<',
		searchType: '<',
		width: '@',
		height: '@',
		onMouseEnter: '&',
		onMouseLeave: '&',
		onClick: '&',
		onUpdateListingPortfolio: '&',
		type: '@'
	},
	controller: ['PubSub', '$element', '$timeout', 'StateService', 'gVariables', function(PubSub, $element, $timeout, StateService, gVariables) {
		var ctrl = this;

		this.$onInit = () => {
			this.pageId = gVariables.pageId;
			this.isGuest = G;
			this.isBroker = B;
			this.widthImage = this.width || 358;
			this.heightImage = this.height || 200;

			if (this.isGuest && this.listing && !this.listing.idx) {
				Core.add_signup_link($($element[0]));
			}
			if (this.isGuest === false) {
				if (!!this.listing && !this.listing.portfolio) {
					this.listing.portfolio = [];
				}
			}
		};

		this.$postLink = function() {
			var hiddenObject = angular.element($element[0].getElementsByClassName('obj-wrapper'));

			if (hiddenObject && hiddenObject.html()) {
				this.listing = JSON.parse(hiddenObject.html());
				this.images = this.listing.images;
				hiddenObject.remove();
			}
		};

		$timeout(function() {
			var image = angular.element($element.find('img'));
			if (image.length) {
				image.bind('error', function() {
					image.attr('src', ctrl.missingImage);
				});
			}
		});

		if (Core.is_ie() || Core.is_edge()) {
			this.onIE = true;
		}

		this.mouseEnter = function() {
			this.onMouseEnter({listing: this.listing});
		};

		this.mouseLeave = function() {
			this.onMouseLeave({listing: this.listing});
		};

		this.updateListingPortfolio = function() {
			this.onUpdateListingPortfolio({listing: this.listing});
		};

		this.click = function($event) {
			$event && $event.preventDefault();
			if ($element.attr('data-rpc') && this.openBlimpOnClick) {
				var widgetToDisplay = 'overview';
				$element.blimp = new BlimpExtV2($element[0], {
					cache: true,
					draggable: true,
					show_veil: false,
					display: widgetToDisplay,
					fullscreen: true, 
					put_others_behind: false,
					onFetch: function() {
						if (ctrl.listing.markerLabel) {
							ctrl.listing.markerLabel.marker.clicked = true;
						}

						_gaq.push(['_trackEvent', 'map', 'loaded', 'view_listing']);
					},
					onPostRpc: function() {
						this.add_extra(true);

						Core.compile_html(this._element);
					}
				});
				$element.blimp.setTrigger($element[0].querySelector('.listing-tile-click'));
			}

			this.onClick();
			
			if (this.redirectLink && this.goToListingPage) {
				location.href = this.redirectLink;
			}
		};
	}]
});
